var map = {
	"./game1.png": 80,
	"./game10.png": 3810,
	"./game2.png": 5483,
	"./game3.png": 1826,
	"./game4.png": 4621,
	"./game5.png": 3492,
	"./game6.png": 5951,
	"./game7.png": 7206,
	"./game8.png": 7009,
	"./game9.png": 4296,
	"./games-banner-bg.png": 8787,
	"./games-bg.png": 8780,
	"./games-logo-1.png": 9258,
	"./games-logo-10.png": 5792,
	"./games-logo-11.png": 617,
	"./games-logo-12.png": 9906,
	"./games-logo-13.png": 7771,
	"./games-logo-14.png": 6116,
	"./games-logo-15.png": 2413,
	"./games-logo-16.png": 790,
	"./games-logo-17.png": 767,
	"./games-logo-18.png": 8504,
	"./games-logo-2.png": 3073,
	"./games-logo-3.png": 5208,
	"./games-logo-4.png": 375,
	"./games-logo-5.png": 8414,
	"./games-logo-6.png": 9413,
	"./games-logo-7.png": 316,
	"./games-logo-8.png": 4475,
	"./games-logo-9.png": 258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1458;